import React, { useEffect, useState } from "react";
import "./detailsProduct.scss";
import productStore from "../../../stores/productStore";
import { Link, useNavigate, useParams } from "react-router-dom";
import categoryStore from "../../../stores/categoryStore";
import {
  Backdrop,
  Box,
  Button,
  Chip,
  CircularProgress,
  Divider,
  FormControl,
  Grid,
  IconButton,
  MenuItem,
  Tab,
  Rating,
  Select,
  Tooltip,
  useMediaQuery,
} from "@mui/material";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import PublishButton from "../../../components/publishButton/PublishButton";
import "react-slideshow-image/dist/styles.css";
import { Fade, Slide } from "react-slideshow-image";
import Reviews from "../../../components/reviews/Reviews";

// Icons
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import EditIcon from "@mui/icons-material/Edit";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import StarRoundedIcon from "@mui/icons-material/StarRounded";
import ShoppingCartCheckoutRoundedIcon from "@mui/icons-material/ShoppingCartCheckoutRounded";
import snackbarStore from "../../../stores/snackbarStore";
import SnackbarAlert from "../../../components/snackbarAlert/snackbarAlert";
import { PRODUCT_IMAGE_URL } from "../../../constant";
import sidebarActivePage from "../../../stores/sidebarActivePage";

const DetailsProduct = () => {
  const matches = useMediaQuery("(min-width:600px)");
  const CategoryStore = categoryStore();
  const ProductStore = productStore();
  const SnackbarStore = snackbarStore();
  const SidebarActivePage = sidebarActivePage();
  const params = useParams();
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();
  const [selectColor, setSelectColor] = useState(null);
  const [showImage, setShowImage] = useState();
  const [tab, setTab] = useState("1");
  const [publish, setPublish] = useState();

  useEffect(() => {
    setShowImage(
      `${PRODUCT_IMAGE_URL}${ProductStore.productForm.productImages[0]}`
    );
  }, [ProductStore.productForm.productImages]);

  useEffect(() => {
    setSelectColor(ProductStore.productForm.productColors[0]);
  }, [ProductStore.productForm.productColors[0]]);

  useEffect(() => {
    setPublish(ProductStore.productForm.publish);
  }, [ProductStore.productForm.publish]);

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handlePublish = async () => {
    setPublish(!publish);
    setAnchorEl(null);
    const res = await ProductStore.updateProductPublish({
      _id: params.productID,
      publish: !publish,
    });
    if (res) {
      SnackbarStore.setMassage({ value: "Updated Successfully" });
      SnackbarStore.setIsOpen({ value: true });
    }
  };

  const fillData = async () => {
    if (params.productID === undefined) {
      setIsLoading(false);
      navigate("/product");
    } else {
      ProductStore.clearProductForm();
      const res = await ProductStore.fillUpdateProduct({
        _id: params.productID,
      });
      if (res === false) return navigate("/product");
      setIsLoading(false);

      await CategoryStore.fetchCategory();
    }
  };

  useEffect(() => {
    SidebarActivePage.setIsActive({ setPage: "Product" });
    fillData();
  }, []);

  return (
    <div className="detailsProduct w-100">
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={isLoading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <SnackbarAlert
        isOpen={SnackbarStore.isOpen}
        alertVariant="filled"
        onClose={() => {
          SnackbarStore.setIsOpen({ value: false });
          SnackbarStore.setMassage({ value: "" });
        }}
        massage={SnackbarStore.massage}
      />
      <Grid container className="header">
        <Grid item xs={6} className="headerLeft">
          <Link to="/product" className="backLink">
            <ArrowBackIosNewIcon className="icon" />
            &nbsp;&nbsp;
            <h3>Back</h3>
          </Link>
        </Grid>
        <Grid item xs={6} className="headerRight">
          <Tooltip title="Go Live">
            <Link>
              <IconButton className="items">
                <OpenInNewIcon />
              </IconButton>
            </Link>
          </Tooltip>
          <Tooltip title="Edit">
            <Link to={`/product/${params.productID}`}>
              <IconButton className="items">
                <EditIcon />
              </IconButton>
            </Link>
          </Tooltip>
          <PublishButton
            anchorEl={anchorEl}
            setAnchorEl={setAnchorEl}
            open={open}
            handleClick={handleClick}
            handleClose={handleClose}
            publish={publish}
            handlePublish={handlePublish}
            buttonName={publish ? "Published" : "Draft"}
          />
        </Grid>
      </Grid>
      <Grid
        container
        sx={{ mt: "2rem" }}
        // spacing={2}
        className="detailContainer"
      >
        <Grid item lg={6} xs={12} md={6} sm={12} className="Carousel">
          {/* <Paper elevation={4} sx={{ borderRadius: "10px", width: "100%" }}>
            <Slide
              autoplay={false}
              nextArrow={<ArrowForwardIosIcon />}
              prevArrow={<ArrowBackIosNewIcon />}
              arrows={matches ? true : false}
              canSwipe={true}
              cssClass="slide"
              onChange={(from, to) => setCarouselIndex(to + 1)}
            >
              {ProductStore.productForm.productImages &&
                ProductStore.productForm.productImages.map((image, index) => (
                  <div key={index} className="singleImage">
                    <Box
                      component="img"
                      sx={{ objectFit: "cover" }}
                      src={image}
                    />
                  </div>
                ))}
            </Slide>
            <Paper elevation={3} className="imageIndex">
              {carouselIndex}/{ProductStore.productForm.productImages.length}
            </Paper>
          </Paper> */}

          <div className="show-image-container">
            <Box className="show-image" component="img" src={showImage} />
          </div>
          <Grid
            container
            spacing={matches ? 2 : 1}
            columns={10}
            className="all-img-container"
          >
            {ProductStore.productForm.productImages &&
              ProductStore.productForm.productImages.map((image, index) => {
                return (
                  <Grid item md={3.2} sm={2} lg={2} xs={2} key={index}>
                    <Box
                      component="img"
                      src={`${PRODUCT_IMAGE_URL}${image}`}
                      className={`single-image  ${
                        showImage === image ? "active" : ""
                      }`}
                      onMouseEnter={() =>
                        setShowImage(`${PRODUCT_IMAGE_URL}${image}`)
                      }
                    />
                  </Grid>
                );
              })}
          </Grid>
        </Grid>
        <Grid item lg={6} xs={12} md={6} sm={12} className="generalDetail">
          <Grid item container spacing={2}>
            <Grid item xs={12} className="product-name">
              <h1>{ProductStore.productForm.productName}</h1>
            </Grid>
            <Grid item xs={12} className="rating">
              <Rating
                name="read-only"
                value={3.5}
                readOnly
                precision={0.5}
                sx={{ fontSize: "23px" }}
                icon={<StarRoundedIcon fontSize="inherit" />}
                emptyIcon={<StarRoundedIcon fontSize="inherit" />}
              />
              <p>(9.12k reviews)</p>
            </Grid>
            <Grid item xs={12} className="price">
              {ProductStore.productForm.salePrice && (
                <div className="sale-price">
                  <h2>₹{ProductStore.productForm.salePrice}</h2>
                  <h3>MRP</h3>
                </div>
              )}
              <div className="regular-price">
                <h2
                  className={
                    ProductStore.productForm.salePrice && "line-through"
                  }
                >
                  ₹{ProductStore.productForm.regularPrice}
                </h2>
              </div>
            </Grid>
            <Grid item xs={12} className="product-sub-description">
              <p>{ProductStore.productForm.productSubDescription}</p>
            </Grid>
            <Grid item xs={12}>
              <Divider />
            </Grid>
            <Grid container item className="product-sizes">
              <Grid item xs={6}>
                Size
              </Grid>
              <Grid
                item
                xs={6}
                sx={{ justifyContent: "flex-end", display: "flex" }}
              >
                {ProductStore.productForm.productSizes.map((size) => (
                  <Chip
                    label={size}
                    onClick={() => {}}
                    className="chip"
                    key={size}
                  />
                ))}
              </Grid>
            </Grid>
            <Grid container item className="product-colors">
              <Grid item xs={6} lg={7}>
                Color
              </Grid>
              <Grid item xs={6} lg={5} className="select-color">
                <FormControl fullWidth size="small">
                  <Select
                    value={selectColor ? selectColor : ""}
                    onChange={(e) => {
                    }}
                  >
                    {ProductStore.productForm.productColors ? (
                      ProductStore.productForm.productColors.map((item) => (
                        <MenuItem value={item} key={item}>
                          {item}
                        </MenuItem>
                      ))
                    ) : (
                      <MenuItem value="noData">No Data</MenuItem>
                    )}
                  </Select>
                </FormControl>
              </Grid>
            </Grid>
            <Grid item xs={12}>
              <Divider />
            </Grid>
            <Grid container item className="btn-group" spacing={2}>
              <Grid item lg={6} xs={6} className="add-to-cart-btn">
                <Button
                  fullWidth
                  variant="contained"
                  startIcon={<ShoppingCartCheckoutRoundedIcon />}
                  className="btn"
                  disabled
                >
                  Add To Cart
                </Button>
              </Grid>
              <Grid item lg={6} xs={6} className="but-now-btn">
                <Button fullWidth variant="contained" className="btn" disabled>
                  Buy Now
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} className="description-reviews">
          <TabContext value={tab}>
            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
              <TabList
                onChange={(event, newValue) => {
                  setTab(newValue);
                }}
                aria-label="lab API tabs example"
              >
                <Tab label="Description" className="tab" value="1" />
                <Tab label="Reviews" className="tab" value="2" />
              </TabList>
            </Box>
            <TabPanel value="1">
              <div
                dangerouslySetInnerHTML={{
                  __html: ProductStore.productForm.productContent,
                }}
              />
            </TabPanel>
            <TabPanel value="2" sx={{ m: 0, p: 0 }}>
              <Reviews productID={params.productID} />
            </TabPanel>
          </TabContext>
        </Grid>
      </Grid>
    </div>
  );
};

export default DetailsProduct;
